import { extendTheme } from "@chakra-ui/react"
import "./fonts/fonts.css"
import platformChakraTheme from "./platformChakraTheme.json"
import pwChakraTheme from "./pwChakraTheme.json"

export const chakraThemeBase = extendTheme(platformChakraTheme)

export const chakraThemePW = extendTheme(pwChakraTheme)
